import React, { useEffect, useState } from 'react';
import CourseAddStep4HoleAndAtBatContainer from './CourseAddStep4HoleAndAtBatContainer'

function CourseAddStep4CourseContainer(props) {
    const [courseName, setCourseName] = useState(props.nowCourse.courseName);
    const [holeAndAtBatList, setHoleAndAtBatList] = useState(props.nowCourse.holeList);

    useEffect(() => {

    }, []);
    return (

        <div className="c-container-horizontal"> {/*<!-- コース名コンテナ -->*/}
            {/*<!-- コース名内容 -->*/}
            <div className="game-data__column">
                <span className="game-data__slot">{courseName}</span>
            </div>
            {/*<!-- コース名の子要素 -->*/}
            <div className="c-container-vertical">
               {/*ここに ホール名」と「規定打数」コンテナをホール数ループ*/}
                {/*動的にコンポーネントが増えていきます*/}
                {holeAndAtBatList.map((holeAndAtBatItem,index) => (
                    <CourseAddStep4HoleAndAtBatContainer
                        key={courseName + "_" + index}
                        nowHoleAndAtBatData={holeAndAtBatItem}
                    />
                ))}

            </div>
        </div>
    )
}



export default CourseAddStep4CourseContainer

